import { createContext, useEffect, useState } from "react";

export const CalculationVisualizerContext = createContext({ graph: null, isPromoFlow: false, includesPricing: false, selectedOrientation: 'h', newNodeData: null, isNewNodeModalOpen: false, isEditNodeModalOpen: false, refreshGraph: false, selectedNode: null });

export const CalculationVisualizerContextProvider = ({ children }) => {
  const [graph, setGraph] = useState(null);
  const [isPromoFlow, setIsPromoFlow] = useState(false);
  const [includesPricing, setIsIncludesPricing] = useState(false);
  const [selectedOrientation, setSelectedOrientation] = useState('h');
  const [isNewNodeModalOpen, setIsNewNodeModalOpen] = useState(false);
  const [newNodeData, setNewNodeData] = useState(null);
  const [refreshGraph, setRefreshGraph] = useState(true);
  const [selectedNode, setSelectedNode] = useState(null);
  const [isEditNodeModalOpen, setIsEditNodeModalOpen] = useState(false);

  return (
    <CalculationVisualizerContext.Provider
      value={{
        graph, 
        setGraph,
        isPromoFlow,
        setIsPromoFlow,
        includesPricing, 
        setIsIncludesPricing,
        selectedOrientation, 
        setSelectedOrientation,
        newNodeData, 
        setNewNodeData,
        isNewNodeModalOpen,
        setIsNewNodeModalOpen,
        refreshGraph, 
        setRefreshGraph,
        selectedNode, 
        setSelectedNode,
        isEditNodeModalOpen, 
        setIsEditNodeModalOpen
      }}
    >
      {children}
    </CalculationVisualizerContext.Provider>
  );
};